import React, {useState} from 'react';
import {motion} from 'framer-motion';
import {useAuth} from '../context/AuthContext';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';

const {FiLock, FiUser, FiEye, FiEyeOff, FiCloud}=FiIcons;

function LoginPage() {
  const [credentials, setCredentials] = useState({username: '', password: ''});
  const [showPassword, setShowPassword] = useState(false);
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const {login} = useAuth();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError('');
    
    const result = await login(credentials.username, credentials.password);
    if (!result.success) {
      setError(result.error);
    }
    
    setLoading(false);
  };

  return (
    <div className="min-h-screen flex items-center justify-center p-4">
      <motion.div 
        initial={{opacity: 0, y: 20}} 
        animate={{opacity: 1, y: 0}} 
        transition={{duration: 0.6}} 
        className="bg-white rounded-2xl shadow-2xl p-8 w-full max-w-md"
      >
        <div className="text-center mb-8">
          <motion.div 
            initial={{scale: 0}} 
            animate={{scale: 1}} 
            transition={{delay: 0.2, type: "spring"}} 
            className="inline-flex items-center justify-center w-16 h-16 bg-blue-100 rounded-full mb-4"
          >
            <SafeIcon icon={FiCloud} className="w-8 h-8 text-blue-600" />
          </motion.div>
          <h1 className="text-3xl font-bold text-gray-800 mb-2">MinterMark Image Portal</h1>
          <p className="text-gray-600">Sign in to access your storage</p>
        </div>
        
        <form onSubmit={handleSubmit} className="space-y-6">
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-2">
              Username
            </label>
            <div className="relative">
              <SafeIcon icon={FiUser} className="absolute left-3 top-3 w-5 h-5 text-gray-400" />
              <input 
                type="text" 
                value={credentials.username} 
                onChange={(e) => setCredentials(prev => ({...prev, username: e.target.value}))} 
                className="w-full pl-10 pr-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent transition-all" 
                placeholder="Enter your username" 
                required 
              />
            </div>
          </div>
          
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-2">
              Password
            </label>
            <div className="relative">
              <SafeIcon icon={FiLock} className="absolute left-3 top-3 w-5 h-5 text-gray-400" />
              <input 
                type={showPassword ? "text" : "password"} 
                value={credentials.password} 
                onChange={(e) => setCredentials(prev => ({...prev, password: e.target.value}))} 
                className="w-full pl-10 pr-12 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent transition-all" 
                placeholder="Enter your password" 
                required 
              />
              <button 
                type="button" 
                onClick={() => setShowPassword(!showPassword)} 
                className="absolute right-3 top-3 text-gray-400 hover:text-gray-600"
              >
                <SafeIcon icon={showPassword ? FiEyeOff : FiEye} className="w-5 h-5" />
              </button>
            </div>
          </div>
          
          {error && (
            <motion.div 
              initial={{opacity: 0, x: -10}} 
              animate={{opacity: 1, x: 0}} 
              className="text-red-600 text-sm bg-red-50 p-3 rounded-lg"
            >
              {error}
            </motion.div>
          )}
          
          <motion.button 
            whileHover={{scale: 1.02}} 
            whileTap={{scale: 0.98}} 
            type="submit" 
            disabled={loading} 
            className="w-full bg-blue-600 text-white py-3 rounded-lg font-medium hover:bg-blue-700 disabled:opacity-50 disabled:cursor-not-allowed transition-all"
          >
            {loading ? 'Signing in...' : 'Sign In'}
          </motion.button>
        </form>
        
        <div className="mt-8 p-4 bg-gray-50 rounded-lg">
          <p className="text-sm text-gray-600 font-medium mb-2">Demo Credentials:</p>
          <div className="space-y-1 text-xs text-gray-500">
            <p><strong>Admin:</strong> admin / admin123</p>
            <p><strong>Client 1:</strong> client1 / client123</p>
            <p><strong>Client 2:</strong> client2 / client456</p>
          </div>
        </div>
      </motion.div>
    </div>
  );
}

export default LoginPage;